module.exports = __webpack_public_path__ + "static/cloud1Mask-95e2f3727b99fa0ee2700cb94c950760.jpg";